angular.module('unica_media_upload.media_controllers', [])

.controller('MediaUploadBasicController',
	function(
		$rootScope, $scope, $stateParams
	) {

	$scope.forms = {};

	$rootScope.mediaData = {
		event_id: $stateParams.event_id,
		files: []
	};

});


